import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";
import { tooltipFormatter } from "@icoach/dashboard/dashboard.util";

/********* 循環蛋白訂購狀況 *********/
const CycleProteinOrders = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			series: {
				data: [
					{
						itemStyle: { color: "#5B0F74" },
						name: "已訂購",
						value: 242,
						meta: { key: "ordered" },
					},
					{
						itemStyle: { color: "#E5EAF1" },
						name: "未訂購",
						value: 130,
						meta: { key: "notOrdered" },
					},
				],
				centerValueText: 65,
			},
		},
	} = props;
	const { series = {} } = sourceData;
	const seriesData = series?.data ?? [];
	const centerValueText = series?.centerValueText ?? "";
	const isLoading = seriesData.length === 0;
	const title = "循環蛋白訂購狀況";
	const subTitle = "在籍會員訂購比例";

	const option = {
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},
		tooltip: {
			trigger: "item",
			formatter: tooltipFormatter,
		},
		legend: {
			bottom: 24,
			left: "center",
			icon: "circle",
			textStyle: {
				fontSize: 14,
				color: "#111827",
			},
		},
		series: [
			{
				name: "訂購狀況",
				type: "pie",
				radius: ["40%", "58%"],
				center: ["50%", "55%"],
				startAngle: 90,
				clockwise: true,
				avoidLabelOverlap: false,
				label: { show: false },
				labelLine: { show: false },
				data: seriesData,
				emphasis: {
					scale: true,
					scaleSize: 8,
					itemStyle: {
						opacity: 1,
						shadowBlur: 12,
						shadowColor: "rgba(0,0,0,0.15)",
					},
				},
			},
		],

		graphic: [
			{
				type: "text",
				left: "center",
				top: "50%",
				style: {
					text: centerValueText + "%",
					fontSize: 36,
					fontWeight: 700,
					fill: "#5B0F74",
					textAlign: "center",
				},
			},
		],
	};

	useEChart(chartDomRef, option);

	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});

export default CycleProteinOrders;
